<template>
  <div class="detail-sjzlpt animate__animated animate__fadeIn">
    <TopCarousel :list="bannerList" :index="0" />
    <div class="bg-white pt-80">
      <div class="flex flex-col items-center justify-center">
        <div class="max-width-1200 flex flex-col items-center">
          <div class="text-[#222] f30 font-shs-medium mb-12 text-center" v-remove-leading="GlobalJson[4].c[0].n"></div>
          <div class="flex justify-center mb-24 text-[#0099D2]">
            <div
              v-for="(item, index) in GlobalJson[4].c[0].c"
              :key="index"
              class="h-44 w-126 cursor-pointer flex items-center justify-center f18 bg-white"
              :class="{ 'bg-[#0099D2] text-white': activeProduct === index }"
              @mouseover="activeProduct = index"
              v-remove-leading="item.n"
            >
            </div>
          </div>
          <div class="text-black w-[80%] f16 text-center h-50">
            {{ GlobalJson[4].c[0].c[activeProduct].t }}
          </div>
          <div class="h-1 w-[90%] bg-[#E6E6E6] my-12"></div>
        </div>
        <div v-if="activeProduct === 0" class="w-full relative h-810">
          <img class="w-full h-810 absolute top-0 left-0" src="../../assets/images/sjzlpt_detail1_background.png" alt="" />
          <img class="max-width-1200 absolute left-0 top-30" style="height: 718px !important" src="../../assets/images/sjzlpt_detail1.png" alt="" />
        </div>
        <img v-else class="max-width-1200" src="../../assets/images/sjzlpt_detail2.png" alt="" />
      </div>
      <div
        class="px-86 py-80 w-full"
        style="background: linear-gradient( 180deg, #FCFEFF 0%, #F1F5F9 100%);"
      >
        <div class="max-width-1200 flex flex-col items-center">
          <div class="text-[#222] f30 font-shs-medium mb-24">产品功能</div>
          <div class="mx-86 w-full rounded-md flex items-stretch" style="box-shadow: 0px 6px 16px 0px rgba(0,0,0,0.15);">
            <div class="w-256 bg-[#7FBAF0] bg-opacity-10">
              <div v-for="(item2, index2) in GlobalJson[4].c[1].c" :key="index2" @mouseover="changeFunction(index2)" :class="{ 'tab-item': true, 'tab-active': activeFunction === index2 }">
                <img class="w-32 h-32 mr-20" :src="activeFunction === index2 ? functionList[index2].icon_active : functionList[index2].icon" alt="">
                <div class="text" v-remove-leading="item2.n"></div>
              </div>
            </div>
            <div class="flex-1 flex flex-col bg-white px-52 py-48">
              <div class="mb-14 text-[#222] f20 font-shs-medium" v-remove-leading="GlobalJson[4].c[1].c[activeFunction].n"></div>
              <div class="f14 text-[#999] mb-24">{{ GlobalJson[4].c[1].c[activeFunction].t }}</div>
              <div class="flex flex-wrap mb-30">
                <div v-for="(item3, index3) in GlobalJson[4].c[1].c[activeFunction].l" :key="index3" class="mr-48 h-44 px-38 bg-[#0099D2] rounded-sm flex items-center justify-center text-white f16">{{ item3 }}</div>
              </div>
              <div class="flex-1 w-full">
                <img class="w-full" :src="pointIcon[activeFunction].icon" alt="">
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="bg-white p-80 w-full">
        <div class="max-width-1200 flex flex-col items-center">
          <div class="text-[#222] f30 font-shs-medium mb-48">核心优势</div>
          <div class="w-full grid grid-cols-3 gap-x-37 gap-y-37">
            <div v-for="(item4, index4) in GlobalJson[4].c[2].c" :key="index4"  class="flex flex-col items-stretch col-span-1 bg-white rounded transform hover:scale-105 transition duration-500 ease-in-out" style="box-shadow: 0px 6px 16px 0px rgba(0,0,0,0.15);">
              <div class="h-94 w-full flex items-center justify-center bg-sjzl1">
                <div class="w-28 h-28">
                  <img class="w-full h-full" :src="advantageIcon[index4].icon" alt="">
                </div>
                <div class="mx-10 f20 text-white font-shs-medium" v-remove-leading="item4.n"></div>
                <div class="w-28 h-28"></div>
              </div>
              <div class="bg-white bg-opacity-[15] f16 text-[#999] font-shs-normal px-32 py-50">{{ item4.t }}</div>
            </div>
          </div>
        </div>
      </div>
      <div class="bg-[#7FBAF0] bg-opacity-10 pt-57">
        <div class="max-width-1200 flex flex-col items-center">
          <div class="text-[#222] f30 font-shs-medium">标杆案例</div>
          <div class="bg-white px-112 py-84 rounded-md mt-40 mb-118 h-540 relative" style="box-shadow: 0px 6px 16px 0px rgba(0,0,0,0.15);">
            <div class="h-full flex items-stretch justify-between">
              <div class="flex-1 mr-100">
                <div class="f20 text-black font-shs-medium mb-12">{{ GlobalJson[4].c[3].t }}</div>
                <div class="text-black f14 mb-12">{{ GlobalJson[4].c[3].l[0].n1 }}</div>
                <div class="text-[#999] f14 mb-12" v-html="GlobalJson[4].c[3].l[0].n2"></div>
                <div class="text-black f14 mb-12">{{ GlobalJson[4].c[3].l[1].n1 }}</div>
                <div class="text-[#999] f14 mb-12">{{ GlobalJson[4].c[3].l[1].n2 }}</div>
              </div>
              <div class="flex-1 relative h-full">
                <img class="absolute left-0 top-0 w-490 h-268" src="../../assets/images/bgal/sjzlpt1.jpeg" alt="">
                <img class="absolute left-52 top-80 w-490 h-268" src="../../assets/images/bgal/sjzlpt2.jpeg" alt="">
              </div>
            </div>
            <div class="btn btn-arrow mt-[-20px]" @click="$router.push({ path: 'case-detail', query: { id: '7' } })">
              <span class="pl-15 f18">案例详情</span>
              <img class="ml-5" src="../../assets/images/arrow_right2.png" alt="">
            </div>
          </div>
        </div>
      </div>
    </div>
    <BottomInfo
      title="立即体验蓝晶数据治理平台"
      :subtitle="GlobalJson[4].c[4].t"
      button="免费体验"
    />
  </div>
</template>
<script>
import TopCarousel from '../../components/TopCarousel.vue'
import BottomInfo from '../../components/BottomInfo.vue'
import GlobalJson from '../../json/index.json'
export default {
  name: 'detail-sjzlpt',
  components: { BottomInfo, TopCarousel },
  data() {
    return {
      GlobalJson,
      bannerList: [
        {
          title: '蓝晶数据治理平台',
          subtitle: '一站式治理，精准洞察数据价值，助力企业高效决策与智慧运营',
          src: require('../../assets/images/banner1@2x.png')
        },
        {
          title: '蓝晶数据中台',
          subtitle: '整合数据资产，构建数据生态，赋能企业创新和数字化转型',
          src: require('../../assets/images/banner3@2x.png')
        },
        {
          title: '宏图BI',
          subtitle: '5分钟搭建数据化可视页面！为企业决策提供有力支持，驱动业务创新',
          src: require('../../assets/images/banner4@2x.png')
        },
        {
          title: '纬业低代码平台',
          subtitle: '简化应用开发流程，快速构建业务应用和响应市场变化',
          src: require('../../assets/images/banner5@2x.png')
        },
      ],
      activeProduct: 0,
      functionList: [
        {
          icon: require('../../assets/images/sjzl_fun1@2x.png'),
          icon_active: require('../../assets/images/sjzl_fun1_active@2x.png'),
        },
        {
          icon: require('../../assets/images/sjzl_fun2@2x.png'),
          icon_active: require('../../assets/images/sjzl_fun2_active@2x.png'),
        },
        {
          icon: require('../../assets/images/sjzl_fun3@2x.png'),
          icon_active: require('../../assets/images/sjzl_fun3_active@2x.png'),
        },
        {
          icon: require('../../assets/images/sjzl_fun4@2x.png'),
          icon_active: require('../../assets/images/sjzl_fun4_active@2x.png'),
        },
        {
          icon: require('../../assets/images/sjzl_fun5@2x.png'),
          icon_active: require('../../assets/images/sjzl_fun5_active@2x.png'),
        },
        {
          icon: require('../../assets/images/sjzl_fun6@2x.png'),
          icon_active: require('../../assets/images/sjzl_fun6_active@2x.png'),
        },
        {
          icon: require('../../assets/images/sjzl_fun7@2x.png'),
          icon_active: require('../../assets/images/sjzl_fun7_active@2x.png'),
        },
      ],
      activeFunction: 0,
      advantageIcon: [
        {
          icon: require('../../assets/images/sjzl_advantage1.png'),
        },
        {
          icon: require('../../assets/images/sjzl_advantage2.png'),
        },
        {
          icon: require('../../assets/images/sjzl_advantage3.png'),
        },
        {
          icon: require('../../assets/images/sjzl_advantage4.png'),
        },
        {
          icon: require('../../assets/images/sjzl_advantage5.png'),
        },
        {
          icon: require('../../assets/images/sjzl_advantage6.png'),
        },
      ],
      pointIcon: [
        {
          icon: require('../../assets/images/sjzlpt/5.2.1.png'),
        },
        {
          icon: require('../../assets/images/sjzlpt/5.2.2.png'),
        },
        {
          icon: require('../../assets/images/sjzlpt/5.2.4.png'),
        },
        {
          icon: require('../../assets/images/sjzlpt/5.2.5.png'),
        },
        {
          icon: require('../../assets/images/sjzlpt/5.2.6.png'),
        },
        {
          icon: require('../../assets/images/sjzlpt/5.2.7.png'),
        },
      ],
    }
  },
  methods: {
    changeFunction(i) {
      this.activeFunction = i
    }
  }
}
</script>
<style lang="scss" scoped>
.detail-sjzlpt {
  .bg-sjzl1 {
    background: url('../../assets/images/sjzl1.png') 100% 100% no-repeat;
    background-size: cover;
  }
  .tab-item {
    height: 82px;
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
    cursor: pointer;
    transition: 0.5s;
    border-radius: 6px 0px 0px 6px;
    border-left: 9px solid transparent;
    .text {
      color: #000;
      font-family: 'Source Han Sans CN-normal';
      font-size: 16px;
      width: 100px;
      text-align: left;
    }
  }
  .tab-item::after {
    position: absolute;
    top: 0px;
    left: 0px;
    bottom: 0px;
    right: 0%;
  }
  .tab-active {
    border-left: 9px solid #7FBAF0;
    background-color: #fff;
    .text {
      color: #144DA0;
    }
  }
  .tab-active::after {
    right: 0%;
  }
}
</style>
